import { BookStore } from "../../flux";

function isScorableBook(isbn) {
  const book = BookStore.get(isbn);
  const bookFeatures = Fraction.Brand.ScoreCenter.enabled && book.features;

  return bookFeatures && bookFeatures.some(f => f.name === "epub-education");
}

function buildUrl(isbn) {
  return Fraction.Helpers.buildScoreCentertUrl(isbn);
}

module.exports = {
  metadata: () => ({
    id: "vcs-button",
    name: i18n.t("vcs-scorable.vcs-tooltip"),
    type: "button",
    learnMore: false,
    toggle: false,
    expanded: false,
    autoShow: false,
    enabled: isbn => isScorableBook(isbn),
    sidebar: {
      icon: "/img/score-center-icon.svg",
      activeMethod: "fill",
      action: isbn => {
        Fraction.Helpers.ssoToOldOnlineURL(buildUrl(isbn), true);
        Fraction.Reporter.gaEvent("scorecenter-launched");
      }
    }
  })
};
